export default __webpack_public_path__ + "static/media/mental-math-guide.671e4109.mp4";